var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyTwitterRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#585C6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1408 5.58984H18.3489L13.5249 11.1812L19.2 18.7898H14.7564L11.2761 14.1753L7.29377 18.7898H5.08434L10.2441 12.8092L4.79999 5.58984H9.35635L12.5023 9.80775L16.1408 5.58984ZM15.3659 17.4495H16.5894L8.69152 6.85975H7.37854L15.3659 17.4495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyTwitterRounded);
export default __webpack_public_path__ + "static/media/grey-twitterRounded.509086741a07ce56197ebf2e4d04788a.svg";
export { ForwardRef as ReactComponent };